import { literal, number, object, optional, string, union } from "valibot";

export type FileContext = "profile_image" | "cover_image" | "bio_link" | "brand_asset" | "email_asset";

export interface GetFileUploadUrlParams {
  fileName: string;
  fileSize: number;
  mimeType: string;
  context: FileContext;
  expiresInMinutes?: number;
  positionXPercentage?: number;
  positionYPercentage?: number;
}

export interface GetFileUploadUrlResult {
  uploadUrl: string;
  relativePath: string;
  expiresAt: string;
  fileId: string;
}

export const getFileUploadUrlRpcContract = {
  name: "getFileUploadUrl",
  paramsSchema: object({
    fileName: string(),
    fileSize: number(),
    mimeType: string(),
    context: union([
      literal("profile_image"),
      literal("cover_image"),
      literal("bio_link"),
      literal("brand_asset"),
      literal("email_asset"),
    ]),
    expiresInMinutes: optional(number()),
    positionXPercentage: optional(number()),
    positionYPercentage: optional(number()),
  }),
  resultSchema: object({
    uploadUrl: string(),
    relativePath: string(),
    expiresAt: string(),
    fileId: string(),
  }),
} as const;
